/**
 * Utility functions for formatting data consistently across the application
 */

/**
 * Format an image URL into a consistent tag format that can be used in content
 * @param imageUrl The URL of the image
 * @param format Optional format string with {url} placeholder (default: '[img src="{url}"]')
 * @returns Formatted image tag string
 */
export const formatImageTag = (
  imageUrl: string, 
  format: string = '[img src="{url}"]'
): string => {
  return format.replace('{url}', imageUrl);
};
